import { Box, Button, Text } from '@domain-group/suit-theme'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser } from '@fortawesome/pro-light-svg-icons'

interface CampaignContactsNoticeProps {
  boxProps: object,
  callbacks: {
    createCampaignContactModal: VoidFunction,
  },
}

const CampaignContactsNotice = (props: CampaignContactsNoticeProps) => {
  const {
    boxProps,
    callbacks: {
      createCampaignContactModal,
    },
  } = props

  return (
    <Box
      padding="large"
      variant="white"
      {...boxProps}
    >
      <Box alignItems="center">
        <Box color="bodyFontLightColor" fontSize="xlarge" width="auto">
          <FontAwesomeIcon icon={faUser} />
        </Box>

        <Box flexDirection={['column', 'row']} flexWrap="wrap" marginLeft="large">
          <Text fontSize="small">
            No vendors added to this campaign.
          </Text>
        </Box>
      </Box>

      <Button
        buttonStyle="primaryEdit"
        onClick={createCampaignContactModal}
        size="medium"
        style={{ marginLeft: 'auto' }}
        //@ts-expect-error
        width="auto"
      >
        Add Contact
      </Button>
    </Box>
  )
}

export default CampaignContactsNotice
